import { Integer, Text, Bool, Num, Float } from "lib/validate";

const bundle = {
	id: Text(),
	type: Text({ inArray: ["percentage", "fixed_amount"] }),
	quantity: Integer({ min: 1 }),
	reward: Num()
};

const bundles = {
	"settings.bundles.text": Text({ max: 55, name: "offer description" }),
	"settings.bundles.prefix": Text({ max: 45, name: "pricing" }),
	"settings.bundles.font_size": Float({ min: 0.5, max: 2, name: "font size" }),
	"settings.bundles.background": { color: true },
	"settings.bundles.color": { color: true },
	"settings.bundles.activeBackground": { color: true },
	"settings.bundles.activeColor": { color: true },
	"settings.bundles.list": { array: bundle }
};

const add_to_unlock_product = {
	isRequired:
		"if:settings.type=add_to_unlock,settings.add_to_unlock.show_suggestions=true,settings.add_to_unlock.recommendation_type=custom_recommendation",
	fieldName: "suggested product",
	id: Text(),
	title: Text(),
	handle: Text(),
	image: Text({ required: false })
};

const add_to_unlock_goal = {
	reward_type: Text({ name: "reward type", inArray: ["discount", "free_shipping", "manual", "gift"] }),
	goal: Num({ name: "spend goal" }),
	goal_type: Text({ inArray: ["relative", "fixed"] }),
	"goal_text.text": Text({ max: 35, min: 3, name: "text" }),
	"goal_text.font_size": Float({ max: 1.2, min: 0.5, name: "font size" }),
	"goal_text.color": { color: true },
	show_goal_text: Bool({ name: "show goal text" }),
	confetti: Bool({ name: "Confetti" }),
	confetti_length: Num({ name: "Confetti count", min: 200, max: 600 }),
	"discount.before": Text({ name: "text before", max: 600 }),
	"discount.type": Text({ name: "discount type", inArray: ["percentage", "fixed_amount"] }),
	"discount.after": Text({ name: "text after", max: 600 }),
	"discount.reward": Num({ name: "reward" }),

	"free_shipping.before": Text({ name: "text before", max: 600 }),
	"free_shipping.after": Text({ name: "text after", max: 600 }),
	"free_shipping.manual": Bool({ required: false, name: "free shipping offer handler" }),

	"manual.before": Text({ name: "text before", max: 600 }),
	"manual.after": Text({ name: "text after", max: 600 })
};

const add_to_unlock = {
	"settings.add_to_unlock.title.text": Text({ max: 40, min: 3, name: "text" }),
	"settings.add_to_unlock.title.font_size": Float({ min: 0.5, max: 2, name: "font size" }),
	"settings.add_to_unlock.title.color": { color: true },

	"settings.add_to_unlock.background": { color: true },
	"settings.add_to_unlock.borderColor": { color: true },

	"settings.add_to_unlock.show_product_details.text": Text({ max: 30, min: 3, name: "text" }),
	"settings.add_to_unlock.show_product_details.font_size": Float({ min: 0.5, max: 2, name: "font size" }),
	"settings.add_to_unlock.show_product_details.color": { color: true },

	"settings.add_to_unlock.upsell_add_button.text": Text({ max: 40, min: 3, name: "text" }),
	// 'settings.add_to_unlock.upsell_add_button.color': { color: true },
	"settings.add_to_unlock.upsell_add_button.font_size": Float({ min: 0.5, max: 2, name: "font size" }),
	"settings.add_to_unlock.show_suggestions": Bool({ name: "Show suggestions" }),

	"settings.add_to_unlock.upsell_confirm_button.text": Text({ max: 40, min: 3, name: "text" }),
	"settings.add_to_unlock.upsell_confirm_button.font_size": Float({ min: 0.5, max: 2, name: "font size" }),

	//TODO: validate shopify product-
	"settings.add_to_unlock.products": { array: add_to_unlock_product },

	"settings.add_to_unlock.goals": { array: add_to_unlock_goal },

	"settings.add_to_unlock.separator.active": Bool({ name: "separator active" }),
	"settings.add_to_unlock.separator.text": Text({ max: 50, name: "separator text" }),
	"settings.add_to_unlock.isActive": Bool({ name: "enable progress bar" })
};

const one_check_up_sell_product_options = {
	values: {
		array: {
			value: Text()
		}
	}
};
const one_check_up_sell_product_variants = {
	isRequired: "if:settings.type=one_check_up_sell",
	fieldName: "one tick upsell product",
	id: Text(),
	title: Text(),
	price: Text(),
	image: Text({ required: false })
};

const one_check_up_sell_product = {
	"product.id": Text({ required: false }),
	"product.title": Text({ required: false }),
	"product.handle": Text({ required: false }),
	"product.variant_id": Text({ required: false }),
	"product.image": Text({ required: false }),
	"product.variants": { array: one_check_up_sell_product_variants }
	// 'settings.one_check_up_sell.product.options': { array: one_check_up_sell_product_options },
};

const one_check_up_sell = {
	"is_ticked_by_default": Bool({ required: false }),
	"include_in_atu": Bool({ required: false }),
	"text": Text({ required: true, name: "text", max: 250 }),
	"product_type": Text({
		inArray: ["existing", "hidden"]
	}),
	...one_check_up_sell_product
};

const multi_one_check_upsell = {
	"settings.multi_one_check_upsell.products": {
		array: one_check_up_sell
	},
}

export const modules = {
	"settings.modules.order": {
		array: {
			value: Text({ inArray: ["order_note", "random_text", "checkout_button"] })
		}
	},
	"settings.modules.random_text.text": Text({ max: 600 }),
	"settings.modules.random_text.active": Bool()
	// 'settings.modules.order_note.text': Text({ max: 300, required: false  }),
	// 'settings.modules.order_note.active': Bool(),
};

const settings = {
	"settings.type": Text({
		inArray: ["bundles", "add_to_unlock", "one_check_up_sell"],
		name: "campaign type"
	}),
	"settings.applied_discount_title": Text({
		required: false,
		name: "discount title"
	}),
	...bundles,
	...add_to_unlock,
	// ...one_check_up_sell,
	...multi_one_check_upsell,
	...modules
};

const target_selected = {
	isRequired: "if:target.type=specific_products",
	fieldName: "target product",
	id: Text(),
	title: Text(),
	handle: Text(),
	image: Text({ required: false })
};

const target = {
	"target.type": Text({ inArray: ["all_products", "specific_products", "specific_collections"] }),
	// "target.selected.*" : Required({inArray: ["all_products", 'specific_products']})
	"target.selected": { array: target_selected }
	// countries
};

const CampaignConstraints = {
	name: Text({ min: 1, max: 30 }),
	...target,
	...settings
};

export default CampaignConstraints;
